import { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import logo from "./assets/images/fullTTlogo.svg";
import "./styles/app.css";

const Home = lazy(() => import("./pages/Home"));
const Projects = lazy(() => import("./pages/Projects"));
const Navbar = lazy(() => import("./components/Navbar"));
const Footer = lazy(() => import("./components/Home/Footer"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Services = lazy(() => import("./pages/Services"));
const OurTeam = lazy(() => import("./pages/OurTeam"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));
const Faq = lazy(() => import("./components/Home/Faq"));

const WithFooter = () => {
  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
};

function App() {
  return (
    <Suspense
      fallback={
        <div className="animate_suspense">
          <div className=" image_anim">
            <img src={logo} alt="" />
          </div>
        </div>
      }
    >
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route element={<WithFooter />}>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/faq" element={<Faq />} />
            <Route exact path="/projects" element={<Projects />} />
            <Route exact path="/about-us" element={<AboutUs />} />
            <Route exact path="/services" element={<Services />} />
            <Route exact path="/ourteam" element={<OurTeam />} />
            <Route exact path="/contact-us" element={<ContactUs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
